import React from "react";
import { useTranslation } from "react-i18next";
import ReactLoading from "react-loading";
import * as Styled from "./styles";

const GOLoading = () => {
  const { t } = useTranslation();
  return (
    <Styled.Loading>
      <ReactLoading type={"bubbles"} color={"black"} width={52} height={52} />
      &nbsp;
      {t("components.common.onLoadingNow")}
    </Styled.Loading>
  );
};

export default GOLoading;
